import { connect } from 'react-redux'
import NewInvoice from '../../components/invoice/invoice.component'
import {
  removeInvoiceRow,
  getInvoicesStart,
  getFinvoiceOperator,
  onInvoiceReview,
  invoicePageChange,
  editInvoice,
  getInvoiceByIdSuccess,
  cancelDeleteInvoice,
  warnInvoiceToDelete,
  getAdminUsersList,
  selectInvoiceCustomer,
  getCountryList,
  getRegisteredUsersList,
  getUserCompanyUpdateInfo
} from '../../actions'
import {
  createMenuItems,
  unitItems,
  alvItems,
  alvPercentageItems
} from '../../utils/invoice.utils'
import { convertToZeroTime } from '../../utils/salary.utils'

const mapStateToProps = (state) => {
  const { loader } = state
  const { showInvoiceItemLoader } = loader
  const { client, adminUser } = state
  const userType = client.user.data[5]

  const invoiceList = [
    { fi: 'Sähköposti', en: 'E-mail', est: 'E-post' },
    { fi: 'Kirjeposti', en: 'Post', est: 'Postkast' },
    { fi: 'Verkkolasku', en: 'E-invoice', est: 'E-arved' }
  ]

  const listPerLang = (listName) => {
    let selectedLang
    if (state.language.lang == undefined) {
      selectedLang = 'fi'
    } else {
      selectedLang = state.language.lang
    }
    if (selectedLang === 'fi') {
      switch (listName) {
        case invoiceList:
          return invoiceList.map((el) => el.fi)
        default:
          return listName
      }
    } else if (selectedLang === 'en') {
      switch (listName) {
        case invoiceList:
          return invoiceList.map((el) => el.en)
        default:
          return listName
      }
    } else if (selectedLang === 'est') {
      switch (listName) {
        case invoiceList:
          return invoiceList.map((el) => el.est)
        default:
          return listName
      }
    }
  }

  const countryList = state.invoice.countryList ? state.invoice.countryList : []
  const invoiceItems = createMenuItems(listPerLang(invoiceList))
  const invoices = state.invoice.invoices.map((item) => ({
    ...item,
    // toDate need to be converted to zero time to avoid time comparison with datepicker time value
    toDate: convertToZeroTime(item.billing_date) // Add this property to make the filter dateTo
  }))

  return {
    language: state.language.lang,
    user: state.oidc.user,
    invoiceRows: state.invoice.invoiceRows,
    customers: state.invoice.customers,
    countryList: countryList,
    invoiceItems: invoiceItems,
    unitItems,
    alvItems,
    alvPercentageItems,
    invoicePages: Math.ceil(state.invoice.invoices.length / 10),
    isEdit: state.invoice.isEdit,
    userType,
    selectedUser: adminUser.selectedUser,
    invoices: invoices,
    showInvoiceItemLoader: showInvoiceItemLoader
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
    getInvoicesStart: (data) => dispatch(getInvoicesStart(data)),
    getFinvoiceOperator: () => dispatch(getFinvoiceOperator()),
    removeInvoiceRow: () => dispatch(removeInvoiceRow()),
    onInvoiceReview: () => dispatch(onInvoiceReview()),
    invoicePageChange: (selected) => dispatch(invoicePageChange(selected)),
    selectInvoiceCustomer: (customer) =>
      dispatch(selectInvoiceCustomer(customer)),
    editInvoice: (invoice_id) => dispatch(editInvoice(invoice_id)),
    getInvoiceByIdSuccess: (result) => dispatch(getInvoiceByIdSuccess(result)),
    cancelDeleteInvoice: () => dispatch(cancelDeleteInvoice()),
    warnInvoiceToDelete: (selected, attached_journal_id) =>
      dispatch(warnInvoiceToDelete(selected, attached_journal_id)),
    getAdminUsersList: () => dispatch(getAdminUsersList()),
    getCountryList: () => dispatch(getCountryList()),
    getRegisteredUsersList: () => dispatch(getRegisteredUsersList()),
    getUserCompanyUpdateInfo: () => dispatch(getUserCompanyUpdateInfo())
  }
}

const mergeProps = (stateProps, dispatchProps, ownProps) =>
  Object.assign({}, stateProps, dispatchProps, ownProps)

const NewInvoiceContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(NewInvoice)

export default NewInvoiceContainer
